import { useEffect } from 'react'
//import { GetGenderMode } from './../../../utilities/BL/Zones'


const Start = ({ isActiveWomensMode }) => {
    //const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)


    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")


            // const response = await GetGenderMode()

            // if (response.success) {
            //     setIsActiveWomensMode(response.data.isWomensModeActive)
            // } else {
            //     setIsActiveWomensMode(false)
            // }
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            {/* Encabezado */}
            <div className='Screen__Start__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/background.png' className='Screen__Welcome__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/background.png' className='Screen__Welcome__Background__Image' />
                )}

                {/* <img src='/img/page/backgrounds/background.png' className='Screen__Welcome__Background__Image' /> */}
                {/* <img src='/img/page/backgrounds/background.png' className='Screen__Welcome__Background__Image' /> */}
            </div>

            {/* Contenido */}
            <section className="Screen__Start__Container Container-FullHeight">
                <div className="Screen__Start__Container__Info">
                    <img src="/img/page/adsl-five.png" className="Screen__Start__Container__Logotipo" alt="Logo" />
                    <p className="Screen__Start__Container__Title">BIENVENID@S</p>
                </div>
            </section>
            
            {/* Pie de página */}
            <div className='Screen__Start__Footer'>
                <p className="text-center FooterCredits">Hecho con ♥ por Interaktia | 2026</p>
            </div>
        </>
    )
}

export { Start };








{/* Encabezado /}
{/* <div className='Screen__Start__Background'>
    {/*selfieFan?.isActiveWomensMode ? (
        //<img src='/img/page/backgrounds/background.png' className='SelfieFan__Screen__Selfie__Background__Image' />
    //) : (
        <img src='/img/page/backgrounds/background.png' className='SelfieFan__Screen__Selfie__Background__Image' />
    //)/}
    <img src='/img/page/backgrounds/background.png' className='Screen__Welcome__Background__Image' />
</div>

<section className="Screen__Start__Container Container-FullHeight">
    {/* <div className="Screen__Start__Container__Lines">
        <div className="Screen__Start__Container__Lines__Line Screen__Start__Container__Lines__Line--Red"></div>
        <div className="Screen__Start__Container__Lines__Line Screen__Start__Container__Lines__Line--White"></div>
        <div className="Screen__Start__Container__Lines__Line Screen__Start__Container__Lines__Line--Red"></div>
        <div className="Screen__Start__Container__Lines__Line Screen__Start__Container__Lines__Line--White"></div>
    </div> /}

    <div className="Screen__Start__Container__Info">
        <img src="/img/page/adsl-five.png" className="Screen__Start__Container__Logotipo" alt="Logo" />
        <p className="Screen__Start__Container__Title">BIENVENID@S</p>
    </div>
</section>

<div className='Screen__Start__Footer'>
    <p className="text-center">Hecho con ♥ por Interaktia | 2026</p>
</div> */}